/**
 * Rollen der Kontaktpersonen eines Schülers.
 *
 * Gespeichert wird der Code in `student_guardians.relationship_type`. `payer`
 * fehlt in der Auswahl absichtlich: die Rolle sucht die Vertragsanlage
 * (`backend/routers/contracts.py`), sie gehört allein dem Zahler. Das Backend
 * weist sie für Kontaktpersonen auch ab.
 */
export const CONTACT_ROLES = [
  { value: 'mother', label: 'Mutter' },
  { value: 'father', label: 'Vater' },
  { value: 'parent', label: 'Erziehungsberechtigt' },
  { value: 'grandparent', label: 'Großeltern' },
  { value: 'sibling', label: 'Geschwister' },
  { value: 'other', label: 'Weitere Person' },
];

// Codes, die nicht aus dem Dialog stammen: der Zahler sowie Altbestand aus
// Import und Online-Anmeldung.
const WEITERE_BEZEICHNUNGEN = {
  payer: 'Zahler',
  guardian: 'Erziehungsberechtigt',
  custodian: 'Erziehungsberechtigt',
  self: 'Teilnehmer:in selbst',
};

/** Anzeigename einer Rolle; unbekannte Codes bleiben lesbar statt leer. */
export function contactRoleLabel(value) {
  if (!value) return 'Kontakt';
  const bekannt = CONTACT_ROLES.find((r) => r.value === value);
  return bekannt?.label || WEITERE_BEZEICHNUNGEN[value] || value;
}
